<template>
  <div v-if="model">
    <v-property-pictures
      :property="model"
      @delete="$emit('fetch')"
      @upload="$emit('fetch')"
    />
    <!-- Download every picture: under the upload frame -->
    <div
      v-if="$roleCan([$laravel.role_admin])"
      class="is-flex is-justify-content-end mt-2"
    >
      <a
        :href="downloadUrl"
        class="button is-primary"
      >
        {{ $t("download") }}
      </a>
    </div>
  </div>
</template>

<script>
import PropertyPictures from "./components/propertyPictures.vue";

export default {
  components: {
    "v-property-pictures": PropertyPictures,
  },
  props: {
    model: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      downloadUrl: this.$laravel.route("api.properties.download_images", {
        property: this.model.id,
      }),
    };
  },
};
</script>
